import type { IMosaicTocExpanded, ITocActionUpdateViewTiFo } from "./interface";

/**
 * Updates which ToC view is currently visible.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the active view.
 * @returns The updated ToC state with the active view applied.
 */
export const toc_updateViewTiFo = (
  state: IMosaicTocExpanded,
  action: ITocActionUpdateViewTiFo,
): IMosaicTocExpanded => ({
  ...state,
  showTiFo: action.showTiFo,
});
